module.exports = __webpack_public_path__ + "img/appointSet_b.1a276cd2.png";